import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
import {
  IPaymentDetail,
  StatutoryPaymentFile,
} from "pages/dashboard/wallets/interface"
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAppNotificationStore } from "stores"
import { formatCurrencyNoSymbol } from "utils/currency"
import getIdFromKey from "utils/getIdFromKey"
import { IPaymentScheduleItem, IPayoutsRes } from "../../interface/payouts"
import {
  paymentSchedulesService,
  PAYMENT_SCHEDULES_ENDPOINTS,
} from "services/paymentSchedulesService"
import { onQueryError } from "utils/utils"
import TopCards from "pages/dashboard/paymentSchedules/Component/TopCards"
import { Input } from "antd"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { ColumnsType } from "antd/es/table"
import { Button, ModalWrapper } from "components"
import { useCustomizationSettingsStore } from "stores/customization-settings"
import CustomCard from "components/new-stuff/ui/CustomCard"
import AllDocPreviewer from "components/new-stuff/ui/AllDocPreviewer"
import { useBackendTableQuery } from "pages/dashboard/performance/components/useBackendTableQuery"
import { queryClient } from "index"
import { AppTable } from "components/new-stuff/app-table"

const StatsPage = ({
  currency_code,
  StatName,
  StatNameSmall,
  ItemId,
  StatustoryId,
  showReportBtn = true,
  showPrepareBtn = true,
}: {
  currency_code: string
  StatName: string
  StatNameSmall: string
  ItemId: string
  StatustoryId?: number
  showReportBtn?: boolean
  showPrepareBtn?: boolean
}) => {
  const { toast } = useAppNotificationStore()
  const myParam = useLocation().search
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { customizationSettings } = useCustomizationSettingsStore()
  const x = new URLSearchParams(myParam).get("x")
  const id = getIdFromKey(x || "")
  const [prepareScheduleModal, setPrepareScheduleModal] = useState(false)

  const { isLoading: isPaymentLoading, data } = useQuery<
    IBaseRes<IPaymentDetail>
  >({
    queryFn: () =>
      paymentSchedulesService.viewPaymentSchedules("detail", x, currency_code),
    queryKey: [
      PAYMENT_SCHEDULES_ENDPOINTS.VIEW_PAYMENT_SCHEDULES,
      x,
      currency_code,
    ],
  })
  const {
    isLoading: isStatustoryLoading,
    isPreviousData: isStatustoryPreviousData,
    data: StatustoryData,
    search,
    handleSearchChange,
    tablePagination,
    setQueryExtraParams,
  } = useBackendTableQuery<IPayoutsRes>({
    queryKeyBase: [PAYMENT_SCHEDULES_ENDPOINTS.SELECT_STATUTORY_ITEMS],
    queryFn: (params) => paymentSchedulesService.selectStatutoryItems(params),
    getTotal: (response) => response?.data?.totalDocs || 0,
    searchParamName: "searchParams",
    initialExtraParams: {
      id,
      payment_schedule_item_type_id: ItemId,
    },
    onSuccess: () => {
      mixPanelEvent(`pay-schedule-${StatNameSmall}-listings`)
    },
  })

  useEffect(() => {
    setQueryExtraParams({
      id,
      payment_schedule_item_type_id: ItemId,
    })
    // handleSearchChange("")
  }, [x, ItemId])

  const { isLoading: isPrepareScheduleLoading, mutate: submitPrepareSchedule } =
    useMutation({
      mutationFn: async (body: any) => {
        const data = await paymentSchedulesService.uploadStatutorySchedule(body)
        return data
      },
      onSuccess: (data) => {
        data?.message && toast.success(data.message)
        setPrepareScheduleModal(false)
        queryClient.invalidateQueries({
          queryKey: [PAYMENT_SCHEDULES_ENDPOINTS.VIEW_PAYMENT_SCHEDULES],
        })
        mixPanelEvent(`pay-schedule-${StatNameSmall}-prepare-success`)
      },
      onError: onQueryError,
    })
  const { isLoading: isRefreshing, mutate: RefreshPayment } = useMutation({
    mutationFn: async (body: any) => {
      const data = await paymentSchedulesService.refreshStatutoryItems(body)

      return data
    },
    onSuccess: (data) => {
      data?.message && toast.success(data.message)
      queryClient.invalidateQueries({
        queryKey: [PAYMENT_SCHEDULES_ENDPOINTS.SELECT_STATUTORY_ITEMS],
      })
    },
    onError: onQueryError,
  })

  const handleConfirm = () => {
    submitPrepareSchedule({
      payment_schedule_id: id,
      payment_schedule_item_type_id: ItemId,
    })
    mixPanelEvent(`pay-schedule-${StatNameSmall}-prepare-init`)
  }
  const UploadedFiles: StatutoryPaymentFile[] | any[] =
    data?.data?.statutoryPaymentFiles?.filter(
      (files) => files.statutory_payment_type_id === StatustoryId
    ) || []

  const TableColumns: ColumnsType<IPaymentScheduleItem> = [
    {
      title: "Beneficiary",
      dataIndex: "beneficiary",
      render: (_, record: IPaymentScheduleItem) => (
        <span className={`font-circular text-sm text-padeBlack`}>
          {record?.beneficiary_name || `Unspecified ${StatName} Office`}
        </span>
      ),
    },
    ...(ItemId === "14"
      ? [
          {
            title: "Tier",
            dataIndex: "tier",
            render: (_: unknown, record: IPaymentScheduleItem) => (
              <span className={`font-circular text-sm text-padeBlack`}>
                {record?.beneficiary_name || `Unspecified ${StatName} Office`}
              </span>
            ),
          },
        ]
      : []),
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_, record: IPaymentScheduleItem) => (
        <span className={`font-circular text-sm text-padeBlack mp-mask`}>
          {record?.currency_symbol}
          {formatCurrencyNoSymbol(Number(record?.amount))}
        </span>
      ),
    },
  ]

  return (
    <div className="mt-[47px] mb-10">
      <TopCards
        data={data?.data}
        typeId={ItemId}
        currencyCode={currency_code}
      />
      {/* TABLE */}
      <div className="bg-white ">
        <div className=" flex   items-start sm:items-center justify-between flex-col-reverse gap-2 sm:flex-row py-[10px] px-4">
          <div className="flex gap-3 w-full sm:w-auto ">
            <Input
              placeholder="Search"
              className="bg-none w-full px-2 outline-none  text-sm h-9"
              prefix={
                <MagnifyingGlassIcon className="w-5 h-5 text-neutral-300" />
              }
              value={search}
              onChange={(e) => {
                handleSearchChange(e.target.value)
              }}
            />
          </div>
          <div className="flex gap-[7px]">
            {showPrepareBtn && (
              <Button
                outline={true}
                onClick={() => {
                  RefreshPayment({
                    payment_schedule_id: id,
                    payment_schedule_item_type_id: ItemId,
                  })
                }}
                submitting={isRefreshing}
              >
                Refresh
              </Button>
            )}
            {StatustoryData?.data?.docs?.length && showReportBtn ? (
              <Button
                outline={true}
                onClick={() => {
                  mixPanelEvent(`pay-schedule-${StatNameSmall}-download-init`)
                  navigate(
                    `/dashboard/payment-schedules/view-${StatNameSmall}-payment/report?id=${data?.data?.payroll_id}&x=${data?.data?.payment_schedule_key}`
                  )
                }}
              >
                View Report
              </Button>
            ) : null}

            {StatustoryData &&
              StatustoryData?.data?.docs?.length > 0 &&
              showPrepareBtn && (
                <Button
                  color="primary"
                  onClick={() => {
                    setPrepareScheduleModal(true)
                  }}
                  disabled={isPrepareScheduleLoading}
                >
                  Prepare schedule
                </Button>
              )}
          </div>
        </div>
        <div className="border ">
          <AppTable
            key={ItemId}
            columns={TableColumns}
            dataSource={StatustoryData?.data?.docs || []}
            rowKey="payment_schedule_item_id"
            loading={isStatustoryLoading || isStatustoryPreviousData}
            className=" text-padeBlack"
            pagination={tablePagination}
          />
        </div>
      </div>
      {/* UPLOAD PROOF */}
      {UploadedFiles && UploadedFiles?.length > 0 && (
        <CustomCard
          title={`Files uploaded by ${customizationSettings?.brand.platformName}`}
          rootClassName="my-2"
        >
          <div>
            <p className="text-sm text-neutral500 mb-4">
              This is where you will find {StatNameSmall} receipts and control
              documents uploaded by {customizationSettings?.brand.platformName}{" "}
              for this payroll.
            </p>
            <div className="flex flex-col items-start justify-center">
              {UploadedFiles?.map((file) => (
                <AllDocPreviewer
                  url={file?.url}
                  documentName={file?.file_name}
                />
              ))}
            </div>
          </div>
        </CustomCard>
      )}
      {/* PROCESS MODAL */}
      {prepareScheduleModal && (
        <ModalWrapper
          title={`Upload ${StatName} Schedule`}
          onClose={() => {
            setPrepareScheduleModal(false)
          }}
        >
          <div className="border p-4   flex flex-col">
            <p className="text-neutral300 text-sm  mt-2">
              After uploading the {StatNameSmall}
              schedule, a new entry will appear in the ‘Payment Schedule’ tab.
              Payments will be processed within 3-5 working days after
              confirmation. Click ‘Confirm’ to proceed
            </p>
            <div className="mt-4 gap-4 flex justify-end items-center">
              <Button
                color="secondary"
                title="Cancel"
                onClick={() => setPrepareScheduleModal(false)}
              >
                Cancel
              </Button>

              <Button
                submitting={isPrepareScheduleLoading}
                color="primary"
                title="Confirm"
                onClick={handleConfirm}
              >
                Confirm
              </Button>
            </div>
          </div>
        </ModalWrapper>
      )}
    </div>
  )
}

export default StatsPage
export const paymentScheduleStatus = [
  {
    id: "1",
    title: "Succeeded",
  },
  {
    id: "2",
    title: "Queued",
  },
  {
    id: "3",
    title: "Reversed",
  },
  {
    id: "4",
    title: "Failed",
  },
  {
    id: "5",
    title: "New",
  },
]
